<template>
    <section class="main">
        <div class="page-wrapper">
            <button class="back-arrow" type="button" aria-label="Go back" @click="$router.back()">
                <i class="bi bi-arrow-left"></i>
            </button>


        <div class="header">
            <div class="header-top">
                <h5>Edit Tenant Info</h5>
                <p class="notice">Sensitive information cannot be edited</p>
            </div>

            <form action="submit" @submit.prevent="handleSendOtp" class="tenant-form">
                <div class="form-row">
                    <div class="form-group">
                        <label for="name">Name</label>
                        <input id="name" type="text" placeholder="Name" v-model="tenant.tenant_name">
                    </div>

                    <div class="form-group">
                        <label for="phone">Tenant Phone</label>
                        <input id="phone" type="text" placeholder="Phone number" v-model="tenant.tenant_phone">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="tenant_id">Tenant ID</label>
                        <input id="tenant_id" type="text" v-model="tenant.tenant_idnumber" placeholder="Tenant's ID" disabled >
                    </div>

                    <div class="form-group">
                        <label for="gender">Gender</label>
                        <input id="gender" type="text" placeholder="Gender" v-model="tenant.gender">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="marital_status">Marital Status</label>
                        <input id="marital_status" type="text" placeholder="Marital status" v-model="tenant.marital_status">
                    </div>

                    <div class="form-group">
                        <label for="arrears">Arrears</label>
                        <input id="arrears" type="text" placeholder="Arrears amount" v-model="tenant.arrears">
                    </div>
                </div>

                <div class="form-actions">
                    <button type="button" class="btn-cancel">Cancel</button>
                    <button type="submit" class="btn-save">Save Changes</button>
                </div>
            </form>
            </div>
        </div>
    </section>
</template>

<script>
import { apiFetch } from "@/services/api.js";

export default {
    data() {
        return{
            tenantId: null,
            tenant:{},
            API_BASE_URL: 'https://golang.roberms.com/api',
            userId:null,
        };        
    },

    async mounted() {
        this.tenantId = this.$route.params.tenant_id;
        await this.fetchTenantData();
    },
 

    methods:{
        
        async fetchTenantData(){
            try{
                const res = await apiFetch('/tenants');
                const tenant = res.find((t)=> t.id == this.tenantId);
                if (tenant){
                    this.tenant = tenant
                }
                console.log(tenant)
                }catch (error){
                    console.log('Tenant fetch error', error)
                }
            },

        
        async handleSendOtp(){
            try{
                const userId = localStorage.getItem('userId');
                const token = localStorage.getItem('token')
                console.log('Token being sent:', token);

                const payload = {
                    tenant_id: this.tenantId,
                    tenant_name: this.tenant.tenant_name,
                    tenant_phone: this.tenant.tenant_phone,
                    gender: this.tenant.gender,
                    marital_status: this.tenant.marital_status,
                    arrears: this.tenant.arrears,
                };
                console.log("Payload being sent:", payload);

                const res = await fetch(`${this.API_BASE_URL}/send-otp`,{
                    method:'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` },
                    body: JSON.stringify( {
                        user_id: userId,
                        action_type:'edit_tenant',
                        payload
                    })
                })

                const data = await res.json()

                if (res.status === 200){
                    this.$router.push({ path: '/sendOtp/', query: { action_type: 'edit_tenant' } });
                }else {
                    console.log("Send OTP failed:", data.error);
                }
            }catch(error){
                console.log("Error sending otp: ", error)
            }
        }
        }

    }

   
</script>


<style scoped>
.main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: var(--dash-bg);
    padding: 2rem;
    box-sizing: border-box;
}

.page-wrapper {
    position: relative;
    width: 100%;
    max-width: 620px;
}

.back-arrow {
    position: absolute;
    top: -1.25rem;
    left: -1.25rem;
    height: 44px;
    width: 44px;
    border: none;
    border-radius: 50%;
    background-color: var(--dash-primary-hover);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    cursor: pointer;
    box-shadow: var(--dash-shadow);
    transition: background 0.2s ease, transform 0.1s ease;
}

.back-arrow:hover {
    background-color: var(--dash-primary-ink);
}

.back-arrow:active {
    transform: scale(0.94);
}


.header {
    width: 100%;
    max-width: 620px;
    background: #ffffff;
    border: 1px solid var(--dash-line);
    border-radius: var(--dash-radius);
    padding: 2rem 2.25rem;
    box-shadow: var(--dash-shadow);
}

.header-top {
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid var(--dash-line);
}

.header-top h5 {
    margin: 0 0 0.35rem 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--dash-ink);
}

.notice {
    margin: 0;
    font-size: 0.85rem;
    color: var(--dash-faint);
    font-style: italic;
}

.tenant-form {
    display: flex;
    flex-direction: column;
    gap: 1.1rem;
}

.form-row {
    display: flex;
    gap: 1.25rem;
}

.form-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    min-width: 0;
}

.form-group label {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--dash-text);
}

.form-group input {
    width: 100%;
    padding: 0.65rem 0.85rem;
    border: 1px solid var(--dash-line-strong);
    border-radius: var(--dash-radius);
    font-size: 0.9rem;
    color: var(--dash-ink);
    background: var(--dash-surface-2);
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-group input::placeholder {
    color: var(--dash-faint);
}

.form-group input:focus {
    outline: none;
    border-color: var(--dash-primary);
    box-shadow: var(--dash-shadow);
    background: #ffffff;
}

.form-group input:disabled {
    background: var(--dash-line);
    color: var(--dash-faint);
    cursor: not-allowed;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 0.5rem;
    padding-top: 1.25rem;
    border-top: 1px solid var(--dash-line);
}

.btn-cancel,
.btn-save {
    padding: 0.6rem 1.4rem;
    border-radius: var(--dash-pill);
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background 0.2s ease, transform 0.05s ease;
}

.btn-cancel {
    background: var(--dash-bg-alt);
    color: var(--dash-muted);
    border-color: var(--dash-line);
}

.btn-cancel:hover {
    background: var(--dash-line);
}

.btn-save {
    background: var(--dash-primary);
    color: #ffffff;
}

.btn-save:hover {
    background: var(--dash-primary-hover);
}

.btn-cancel:active,
.btn-save:active {
    transform: scale(0.98);
}

@media (max-width: 480px) {
    .form-row {
        flex-direction: column;
        gap: 1.1rem;
    }
}
</style>